export const formLabelLocale = {
    optional: '(optional)',
};
//# sourceMappingURL=FormLabel.locale.mjs.mjs.map